import { c as _c } from "react/compiler-runtime";
import type { PeripheralBalanceType } from '@morpho-org/blue-sdk';
import type { InterfaceToken } from '@morpho-org/dapp-core';
import { useMemo } from 'react';
import type { PeripheralTokenOption } from '../types';
import SwitchPeripheralSources from '../SwitchPeripheralSources';
interface PeripheralSourcesStackProps {
  token: InterfaceToken | null | undefined;
  peripheralTokenOptions: PeripheralTokenOption[];
  isInputElementDisabled?: boolean;
  onPeripheralTokenChange?: (id: PeripheralBalanceType, isActive: boolean) => void;
}
const PeripheralSourcesStack = t0 => {
  const $ = _c(11);
  const {
    token,
    peripheralTokenOptions,
    isInputElementDisabled,
    onPeripheralTokenChange
  } = t0;
  let t1;
  if ($[0] !== peripheralTokenOptions) {
    const t2 = peripheralTokenOptions.filter(_temp);
    const t3 = peripheralTokenOptions.filter(_temp2);
    const t4 = peripheralTokenOptions.filter(_temp3);
    let t5;
    if ($[2] !== t2 || $[3] !== t3 || $[4] !== t4) {
      t5 = {
        wrapping: t2,
        staking: t3,
        deposit: t4
      };
      $[2] = t2;
      $[3] = t3;
      $[4] = t4;
      $[5] = t5;
    } else {
      t5 = $[5];
    }
    t1 = Object.entries(t5);
    $[0] = peripheralTokenOptions;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const entries = t1;
  let t2;
  if ($[6] !== entries || $[7] !== isInputElementDisabled || $[8] !== onPeripheralTokenChange || $[9] !== token) {
    t2 = <div className="gap-xs flex flex-col">{entries.map(t3 => {
        const [key, options] = t3;
        return options.length > 0 && <div className="gap-md flex flex-nowrap items-center justify-between" key={key}><span className="text-3xs text-secondary-foreground leading-none whitespace-nowrap">Allow {key}:</span><div className="gap-xs flex flex-wrap items-center justify-end">{options.map(option_2 => <div className="gap-2xs flex flex-row flex-nowrap items-center" key={option_2.id}><span className="text-3xs text-secondary-foreground leading-none">{option_2.srcToken.symbol}</span><SwitchPeripheralSources peripheralBalanceType={option_2.id} active={option_2.value} isDisabled={isInputElementDisabled} baseToken={token} srcToken={option_2.srcToken} ctaAction={isActive => onPeripheralTokenChange?.(option_2.id, !isActive)} /></div>)}</div></div>;
      })}</div>;
    $[6] = entries;
    $[7] = isInputElementDisabled;
    $[8] = onPeripheralTokenChange;
    $[9] = token;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
};
export default PeripheralSourcesStack;
function _temp(option) {
  return option.id === "wrapped";
}
function _temp2(option_0) {
  return option_0.id === "staked-wrapped" || option_0.id === "unwrapped-staked-wrapped";
}
function _temp3(option_1) {
  return option_1.id === "vault" || option_1.id === "wrapped-vault";
}